<template>
  <form-wrapper @submit="onSubmit">
    <div slot="box" v-loading="loading">
      <el-form-item label="Title" :error="errors['title']" required>
        <el-input v-model="form['title']" />
      </el-form-item>
      <el-form-item
        label="Alternative text (for readers)"
        :error="errors['alt']"
      >
        <el-input v-model="form['alt']" />
      </el-form-item>
      <div>
        <h2>Image</h2>
        <image-cropper
          v-if="form.file_url && (showAllCrops || onlyShowNormalCrop)"
          v-model="form.normal_crop.file"
          :src="form.file_url"
          :cropTop.sync="form.normal_crop.top"
          :cropLeft.sync="form.normal_crop.left"
          :cropWidth.sync="form.normal_crop.width"
          :cropHeight.sync="form.normal_crop.height"
          header="Default"
          :stencilWidth="1122"
          :stencilHeight="597"
        />
        <image-cropper
          v-if="form.file_url && (showAllCrops || onlyShowCoverCrop)"
          v-model="form.cover_crop.file"
          :src="form.file_url"
          :cropTop.sync="form.cover_crop.top"
          :cropLeft.sync="form.cover_crop.left"
          :cropWidth.sync="form.cover_crop.width"
          :cropHeight.sync="form.cover_crop.height"
          header="Cover"
          :stencilWidth="1122"
          :stencilHeight="350"
        />
        <image-cropper
          v-if="form.file_url && (showAllCrops || onlyShowGalleryCrop)"
          v-model="form.gallery_crop.file"
          :src="form.file_url"
          :cropTop.sync="form.gallery_crop.top"
          :cropLeft.sync="form.gallery_crop.left"
          :cropWidth.sync="form.gallery_crop.width"
          :cropHeight.sync="form.gallery_crop.height"
          header="Gallery"
          :stencilWidth="924"
          :stencilHeight="568"
        />
        <p>To change image</p>
        <upload-tab @submit="changeImage" />
      </div>
    </div>
    <form-nav
      :loading="loading"
      slot="navbar"
      @submit="onSubmit"
      :inModal="inModal"
      modalLabel="Edit image"
      :redirectRoute="redirectRoute"
    />
  </form-wrapper>
</template>
<script>
import { Image } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import UploadTab from '@/components/inputs/ImageDialog/UploadTab'
import ImageCropper from './ImageCropper'

export default {
  mixins: [FormMixin],
  props: {
    onlyShowNormalCrop: {
      default: false
    },
    onlyShowCoverCrop: {
      default: false
    },
    onlyShowGalleryCrop: {
      default: false
    },
    defaultThumbnail: {
      default: false
    }
  },
  components: {
    UploadTab,
    ImageCropper
  },
  data() {
    return {
      redirectRoute: { name: 'Image List' }
    }
  },
  methods: {
    instanceFetchCallback() {
      this.prepareFormCopyToPreventChangesLost()
      if (!this.form.normal_crop) {
        this.form.normal_crop = {}
      }
      if (!this.form.cover_crop) {
        this.form.cover_crop = {}
      }
      if (!this.form.gallery_crop) {
        this.form.gallery_crop = {}
      }
    },
    getPreparedPayload(payload) {
      if (
        payload.hasOwnProperty('normal_crop') &&
        typeof payload.normal_crop.file !== 'object'
      ) {
        delete payload.normal_crop.file
      }
      if (
        payload.hasOwnProperty('cover_crop') &&
        typeof payload.cover_crop.file !== 'object'
      ) {
        delete payload.cover_crop.file
      }
      if (
        payload.hasOwnProperty('gallery_crop') &&
        typeof payload.gallery_crop.file !== 'object'
      ) {
        delete payload.gallery_crop.file
      }
      return payload
    },
    changeImage(image) {
      if (!image) return
      this.$set(this.form, 'file', image)
      for (let key of ['normal_crop', 'cover_crop', 'gallery_crop']) {
        if (!this.form.hasOwnProperty(key)) {
          this.$set(this.form, key, {})
        }
      }
      this.updateImagePreview()
    },
    updateImagePreview() {
      const value = this.form.file
      const fileType = typeof value
      if (fileType === 'object') {
        const reader = new FileReader()
        reader.onload = e => {
          this.$set(this.form, 'file_url', e.target.result)
        }
        reader.readAsDataURL(this.form.file)
      }
    }
  },
  computed: {
    service() {
      return Image
    },
    showAllCrops() {
      return (
        !this.onlyShowCoverCrop &&
        !this.onlyShowNormalCrop &&
        !this.onlyShowGalleryCrop
      )
    }
  }
}
</script>
